module.exports = __webpack_public_path__ + "static/media/84.5d0c2219.jpg";